import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, Eye, EyeOff } from "lucide-react";
import { authApi } from "../../services/api";

export default function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    setError("");
    try {
      await authApi.resetPassword(token, password);
      setComplete(true);
    } catch (err) {
      setError(err.response?.data?.message || "Unable to reset your password.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-shell auth-shell-centered">
      <div className="auth-card auth-card-solo">
        {complete ? (
          <div className="auth-sent-state">
            <span className="auth-sent-icon"><CheckCircle2 size={32} /></span>
            <h1>Password updated</h1>
            <p className="auth-sub">Your new password is ready to use.</p>
            <Link to="/login" className="auth-submit">Continue to sign in</Link>
          </div>
        ) : (
          <>
            <div className="auth-card-header">
              <h1>Choose a new password</h1>
              <p className="auth-sub">Use at least 8 characters.</p>
            </div>
            {error && <div className="auth-error" role="alert">{error}</div>}
            <form onSubmit={handleSubmit} noValidate>
              <div className="auth-field">
                <label htmlFor="new-password">New password</label>
                <div className="auth-input-wrap">
                  <input id="new-password" type={showPassword ? "text" : "password"} autoComplete="new-password" value={password} onChange={(event) => { setPassword(event.target.value); setError(""); }} />
                  <button type="button" className="auth-eye" onClick={() => setShowPassword((shown) => !shown)} aria-label="Toggle password visibility">
                    {showPassword ? <EyeOff size={17} /> : <Eye size={17} />}
                  </button>
                </div>
              </div>
              <div className="auth-field">
                <label htmlFor="confirm-password">Confirm password</label>
                <input id="confirm-password" type={showPassword ? "text" : "password"} autoComplete="new-password" value={confirmPassword} onChange={(event) => { setConfirmPassword(event.target.value); setError(""); }} />
              </div>
              <button type="submit" className="auth-submit" disabled={loading}>
                {loading ? <span className="auth-spinner" /> : "Update password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
